import Page from '~/containers/Views/Maintenance';

export default Page;
